export default "__VITE_ASSET__Dw$K$rO$__"